import { render, staticRenderFns } from "./COAAddSubAccountModal.vue?vue&type=template&id=1b2c492b&scoped=true&"
import script from "./COAAddSubAccountModal.vue?vue&type=script&lang=js&"
export * from "./COAAddSubAccountModal.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1b2c492b",
  null
  
)

export default component.exports